module.exports = "# version 300 es\n\nvoid main()\n{             \n    // gl_FragDepth = gl_FragCoord.z;\n}  "


//////////////////
// WEBPACK FOOTER
// ./src/shaders/depth-frag.glsl
// module id = 78
// module chunks = 0